'use strict';

const React = require('react'),
    { t } = require('services/i18nextWrapper'),
    InventoryStore = require('stores/InventoryStore'),
    NumberUtils = require('utils/NumberUtils'),
    ContentUtils = require('utils/ContentUtils'),
    NavigationUtils = require('utils/NavigationUtils'),
    PositionUtils = require('utils/PositionUtils'),
    { map, find, filter } = require('lodash/collection'),
    { Navigation } = require('react-router'),
    Constants = require('constants/AppConstants'),
    { delay } = require('lodash/function'),
    Loading = require('components/Commons/Loading/Loading'),
    Notification = require('components/Notification/Notification'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    AdminScaffoldingTablePaged = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTablePaged'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Authentication = require('services/Security').Authentication,
    get = require('lodash/object').get,
    InventoryAndTransfersModal = require('./InventoryAndTransfersModal/InventoryAndTransfersModal'),
    InventoryAndTransfersAdjustsModal = require('./InventoryAndTransfersAdjustsModal/InventoryAndTransfersAdjustsModal'),
    ga = require('react-ga');

let InventoryAndTransfersAdmin = React.createClass({displayName: "InventoryAndTransfersAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    _modalTransfer: null,

    _modalAdjust: null,

    getInitialState() {
        return {
            isFetching: true,
            selectLocationItemId: null,
            filter: {
                description: '', category: '', subCategory: '', amount: '', locationName: '', totalAmount: ''
            }
        };
    },

    componentDidMount() {
        this.fetchItems();
        ga.pageview('/inventory-and-transfers');
    },

    fetchItems() {
        const self = this;
        const currentPage = NavigationUtils.getPathParam('page');
        InventoryStore.fetchAllItems(function (items) {
            InventoryStore.fetchLocation(function (locations) {
                InventoryStore.fetchLocationItemsWithTotalAmount(currentPage, function (locationItems) {
                    const enableLocationItems = ContentUtils.filterEnable(locationItems);
                    const enableLocations = ContentUtils.filterEnable(locations);
                    const enableItems = ContentUtils.filterEnable(filterNonInventoryItems(items));
                    const filteredEnableLocationItems = enableLocationItems.filter(filterLocationItemNonDefaultItemWithAmountZero(items));
                    self.setState({
                        locations,
                        locationItems: self._hydrateLocationItems(enableLocations, enableItems, filteredEnableLocationItems),
                        selectLocationItemId: NavigationUtils.getQueryParam('selectLocationItemId'),
                        isFetching: false,
                        items: enableItems
                    }, self._onFinishRenderingFetchLocationItems);
                });
            });
        });
    },

    _hydrateLocationItems(locations, items, locationItems) {

        // add some extra visual information
        const locationItemsFormatted = map(locationItems, locationItem => {
            locationItem.amount = get(locationItem, 'amount');
            locationItem.totalAmount = NumberUtils.formatDecimal(get(locationItem, 'totalAmount')) + ' ' + get(locationItem, 'unit', '');
            locationItem.amountWithUnit = NumberUtils.formatDecimal(get(locationItem, 'amount')) + ' ' + get(locationItem, 'unit', '');
            locationItem.locationName = get(locationItem, 'location.name') || get(locationItem, 'locationName');
            locationItem.description = get(locationItem, 'item.description') || get(locationItem, 'description');
            locationItem.category = get(locationItem, 'item.category') || get(locationItem, 'category');
            locationItem.subCategory = get(locationItem, 'item.subCategory') || get(locationItem, 'subCategory');
            return locationItem;
        });

        return locationItemsFormatted;
    },

    fetchItemsBy(filter) {
        const self = this;
        filter.code = '';
        filter.unit = '';
        filter.salePrice = '';
        filter.weight = '';
        InventoryStore.fetchItemsBy(filter, function (items) {
            InventoryStore.fetchLocationItemsWithTotalAmountBy(filter, locationItems => {
                const enableLocationItems = ContentUtils.filterEnable(locationItems);
                const filteredLocationItems = enableLocationItems.filter(filterLocationItemNonDefaultItemWithAmountZero(items));
                self.setState({
                    locationItems: self._hydrateLocationItems(self.state.locations, items, filteredLocationItems),
                    selectedItemId: NavigationUtils.getQueryParam('selectedItemId'),
                    isFetching: false
                });
            });
        });
    },

    _onFinishRenderingFetchLocationItems() {
        const { selectLocationItemId, locationItems } = this.state;
        const haveProductSelectedTable = !!selectLocationItemId;

        if (haveProductSelectedTable) {
            const self = this;
            this.setState({
                selectLocationItem: find(locationItems, locationItem => get(locationItem, 'id') === +selectLocationItemId)
            }, () => {
                self._setPositionScrollById.bind(self)(selectLocationItemId);
            });
        }
    },

    _setPositionScrollById(productSelectedId) {
        const tableEl = this.getDOMNode().querySelector('.mui-body-table');
        const rowEl = tableEl.querySelector(`tr[data-row-id="${productSelectedId}"]`);
        const positionTopRowEl = PositionUtils.elementScrollTop(rowEl);
        tableEl.scrollTop = positionTopRowEl;
    },

    _openTransfersModal() {
        const amount = get(this.state, 'selectLocationItem.amount');
        if (NumberUtils.isGreater(amount, 0)) {
            this._modalTransfer.show(this.state.selectLocationItem);
        } else {
            Notification.show(t('inventory_and_transfer_main_error_no_amount_to_transfer'));
        }
    },

    _openAdjustsModal() {
        this._modalAdjust.show(this.state.selectLocationItem);
    },

    _onRowSelection(locationItem, itemIndex, lastRowScrollPosition, headerActiveFilters) {
        this.setState({
            selectLocationItem: locationItem,
            headerActiveFilters
        },
            () => {
                // stay the position of the scroll after row select when
                // the offset is outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;

                this._addQueryParamWithRowSelected(locationItem, lastRowScrollPosition);
            }
        );
    },

    _addQueryParamWithRowSelected(locationItem, lastRowScrollPosition) {
        this.transitionTo(
            `/location-item/page/:page`,
            { page: NavigationUtils.getPathParam('page') },
            {
                selectLocationItemId: get(locationItem, 'id')
            }
        );
        // Is needed to force scroll position again
        // in order to avoid jumping scroll behavior
        delay(() => {
            this.getDOMNode().querySelector(
                '.mui-body-table'
            ).scrollTop = lastRowScrollPosition;
        }, 1);
    },

    _onCancel() {
        this.transitionTo('/location-item/page/:page', { page: NavigationUtils.getPathParam('page') });
        this.setState({
            selectLocationItem: null,
            selectLocationItemId: null,
            filter: { description: '', category: '', subCategory: '', amount: '', locationName: '', totalAmount: '' }
        });
    },

    reset() {
        this.setState({
            selectLocationItem: null,
            selectLocationItemId: null,
            filter: { description: '', category: '', subCategory: '', amount: '', locationName: '', totalAmount: '' }
        }, () => {
            this.fetchItems();
        });
    },

    _onTypingFilter(name, match) {
        if (!this.state.isFetching) {
            this.setState(prevState => {
                let nextFilter = prevState.filter || {};
                nextFilter[name] = match;
                this.fetchItemsBy(nextFilter);
                return {
                    filter: nextFilter,
                    isFetching: true
                };
            });
        }
    },

    _onClickPage(page) {
        this.transitionTo('/location-item/page/:page', { page });
        this.fetchItems();
    },

    _printReport() {
        InventoryStore.downloadReportXLS(this.state.filter, 'locations/items');
    },

    render() {
        if (this.state.isFetching) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('inventory_and_transfer_main_change_success'),
                changeFailureMessage: t('inventory_and_transfer_main_failure'),
                deleteSuccessMessage: t('inventory_and_transfer_main_delete_success'),
                addSuccessMessage: t('inventory_and_transfer_main_add_success'),
                addFailureMessage: t('inventory_and_transfer_main_add_failure')
            };
            const CATEGORIES_TEXTS = Constants.getCategoryMapping(t);
            let contextHolder = this.getContextHolderInstance();
            let { selectLocationItem, typeTank, currentBeerStyle, locationItems, locations, isFetching } = this.state;

            let formFieldsEl = [];
            const isItemSelected = !!selectLocationItem;
            const existMoreThanOneLocation = (get(ContentUtils.filterEnable(locations), 'length') || 0) >= 2;

            let additionalButtons = [{
                type: 'NEW',
                permission: 'SHOW',
                el: (
                    React.createElement(FormGroupButton, {
                        label: t('inventory_and_transfer_print_report'), 
                        icon: "file_download", 
                        type: "icon", 
                        onClick: this._printReport}
                    )
                )
            }];

            if (isItemSelected) {
                if (existMoreThanOneLocation) {
                    additionalButtons.push({
                        type: 'CHANGE',
                        permission: 'TRANSFER_SHOW',
                        el: (
                            React.createElement(FormGroupButton, {
                                label: t('inventory_and_transfer_transfer'), 
                                icon: "compare_arrows", 
                                type: "icon", 
                                onClick: this._openTransfersModal}
                            )
                        )
                    });
                }

                additionalButtons.push({
                    type: 'CHANGE',
                    permission: 'ADJUST_SHOW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('inventory_and_transfer_adjust'), 
                            icon: "adjust", 
                            type: "icon", 
                            onClick: this._openAdjustsModal}
                        )
                    )
                });
            }

            const count = get(locationItems, '0.totalSize') || 0;

            if (locationItems && locationItems.length) {
                locationItems = locationItems.map(item => {
                    item.displayCategory = CATEGORIES_TEXTS[item.category] || item.category;
                    return item;
                });
            }
            return (
                React.createElement("div", {className: "bp-location-item"}, 
                    React.createElement(InventoryAndTransfersModal, {
                        ref: ref => this._modalTransfer = ref, 
                        selectedLocationItem: selectLocationItem, 
                        locations: locations, 
                        locationItems: locationItems, 
                        onClose: this.reset}
                    ), 
                    React.createElement(InventoryAndTransfersAdjustsModal, {
                        ref: ref => this._modalAdjust = ref, 
                        selectedLocationItem: selectLocationItem, 
                        locations: locations, 
                        items: locationItems, 
                        onClose: this.reset}
                    ), 
                    React.createElement(AdminScaffolding, {
                        moduleName: "ADMIN_INVENTORY_AND_TRANSFERS", 
                        messages: messages, 
                        additionalSubmitValue: { styleBeerId: currentBeerStyle, typeTank: typeTank}, 
                        title: t('inventory_and_transfer_main_title'), 
                        contextHolder: contextHolder, 
                        value: selectLocationItem, 
                        fetchItems: this.fetchItems, 
                        headerFields: formFieldsEl, 
                        onCancel: this._onCancel, 
                        additionalButtons: additionalButtons
                    }, 
                        React.createElement(AdminScaffoldingTablePaged, {
                            customHeightTable: 290, 
                            headerActiveFilters: this.state.headerActiveFilters, 
                            sortByColumn: ['description'], 
                            onRowSelection: this._onRowSelection, 
                            value: selectLocationItem, 
                            columnNames: [
                                t('inventory_and_transfer_column_item'),
                                t('inventory_and_transfer_column_category'),
                                t('inventory_and_transfer_column_sub_category'),
                                t('inventory_and_transfer_column_location_name'),
                                t('inventory_and_transfer_column_amount'),
                                t('inventory_and_transfer_column_total_amount')
                            ], 
                            filteredColumns: ['description', 'category', 'subCategory', 'locationName', 'amountWithUnit', 'totalAmount'], 
                            displayAttributes: ['description', 'category', 'subCategory', 'locationName', 'amountWithUnit', 'totalAmount'], 
                            isLoading: isFetching, 
                            maxPage: ContentUtils.getAmountPageNeeded(count, Constants.MAX_ITEMS_BY_PAGES_ADMINS), 
                            onClickPage: this._onClickPage, 
                            currentPage: NavigationUtils.getPathParam('page'), 
                            columnsFilterValue: this.state.filter, 
                            onCancel: this._onCancel, 
                            onTypingFilter: this._onTypingFilter
                        }, 
                            locationItems
                        )
                    )
                )
            );
        }
    }
});

function filterNonInventoryItems(items) {
    return filter(items, item => get(item, 'category') !== Constants.ITEM_CATEGORY_NON_INVENTORY);
}

function filterLocationItemNonDefaultItemWithAmountZero(items) {
    return function (locationItem) {
        try {
            if (NumberUtils.isGreater(locationItem.amount, 0)) {
                return true;
            }
            const item = (items || []).find(item => item.id === locationItem.itemId);
            return item &&
                locationItem &&
                item.preferredLocation &&
                item.preferredLocation.id === locationItem.locationId;
        } catch (error) {
            // in case of error, do nothing
        }
        return true;
    };
}

module.exports = InventoryAndTransfersAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/InventoryAndTransfersAdmin/InventoryAndTransfersAdmin.jsx
 **/